import PageTitleComponent from "../../components/PageTitle";
import UserProfileView from "../../components/Profile";

export default function ProfileScreen(){
return <div>
    <PageTitleComponent title="Profile" />
    <UserProfileView/>
</div>
}